import React, { Component } from "react";
import QRCode from 'qrcode.react';
import {isMobile} from 'react-device-detect';

export default class Media extends Component {
  constructor(){
    super()
    let date = Date.now();
    this.state = {text:`http://borderless-internal.blockcollider.org.s3-website.us-east-2.amazonaws.com/#/media?kg,${date}`};
  }
  componentDidMount(){
    let _this = this;
    setInterval(()=>{
      let date = Date.now();
      _this.setState({text:`http://borderless-internal.blockcollider.org.s3-website.us-east-2.amazonaws.com/#/media?kg,${date}`})
    },10000)
  }
  render() {
    return (
      <div className='container center'>
        <div className='center' style={{marginTop:'150px'}}>
          <QRCode
            style={{marginTop:'10px'}}
            size={400}
            value={this.state.text}
            bgColor={"#ffffff"}
            fgColor={"#000000"}
            level={"L"}
            includeMargin={true}
            imageSettings={{
              src: "./overlineblack.jpg",
              x: null,
              y: null,
              height: 66,
              width: 51,
              excavate: true,
            }}
          />
          </div>
      </div>
    );
  }
}
